<deletemodal id="customer-tabs" [deleteModal]="activateDeactivatePopup"></deletemodal>
     <!-- popup for addnew TicketType -->
<modal #createTicketModal class="createTicketModal-header">     
    <modal-header>
        <div class="color-blue" *ngIf="!isUpdate">{{'config-system.ADD NEW TICKET TYPE' |translate |translateKey}}</div>
        <div class="color-blue" *ngIf="isUpdate">{{'config-system.MANAGE TICKET TYPE' |translate  |translateKey}}</div>
    </modal-header>   
    <modal-content>                
        <form *ngIf="ticketTypeForm" [formGroup]="ticketTypeForm" (ngSubmit)="onSubmit(ticketTypeForm.valid)" style="margin-left: -15px;width: 104%;"
            class="col-xs-12 ticket-color-validation" novalidate>
            <div class="row no-margin">
                <div class="row form-horizontal">
                    <label for="operatingCountryId" class="col-sm-3 col-form-label">{{'config-system.Operating Country' |translate |translateKey}}</label>
                    <div class="col-sm-6 floating-input">                          
                        <select autofocus tabindex="0" id="autofocus-modal-element" class="form-control ng-pristine ng-invalid ng-touched"  formControlName="operatingCountryId" [attr.disabled]="!isUpdate?null:''">
                                <option *ngIf = "isCountriesLoading" value="">{{'department-system.Loading...' |translate |translateKey}}</option>
                                <option value="">{{'config-system.--Select--' |translate |translateKey}}</option>
                               <option *ngFor="let country of operatingCountries | orderBy:'name'" [value]="country.id">{{country.name}}</option>
                        </select>
                        <div class="alert-msg" *ngIf="!ticketTypeForm.controls['operatingCountryId'].valid  && ticketTypeForm.controls['operatingCountryId'].hasError('required') && (ticketTypeForm.controls['operatingCountryId'].touched || isSubmitted)">
                            {{'validation-message.required'|translate |translateKey}}
                        </div>
                    </div>
                </div>
                <div class="row clearboth">
                    <label for="ticketType" class="col-sm-3 col-form-label">{{'config-system.Ticket Type' |translate |translateKey}}</label>
                    <div class="col-sm-6 floating-input ">
                        <input id="tkttypename-focus" tabindex="0" type="text" class="form-control pl-5"  formControlName="ticketType" placeholder="{{'config-system.Ticket Type' |translate}}">
                        <div class="alert-msg" *ngIf="!ticketTypeForm.controls['ticketType'].valid  && ticketTypeForm.controls['ticketType'].hasError('required') && (ticketTypeForm.controls['ticketType'].touched || isSubmitted)">
                            {{'validation-message.required'|translate |translateKey}}
                        </div>
                    </div>
                </div>

                <div class="row clearboth" >
                    <label for="ticketTypeStatus" class="col-sm-3 col-form-label">&nbsp;</label>
                    <div class="col-sm-6 ">
                        <input tabindex="0" type="checkbox"  id="status" checked="true" [(ngModel)]="ticketTypeStatus" formControlName ="ticketTypeStatus"  [attr.disabled]="isUpdate && deactivatePermission?null:''"/>
                        <label>{{'config-system.Active' |translate |translateKey}}</label>
                    </div>
                </div>    

            </div>
    
            <div class="pull-right pad-r-8">
                <button tabindex="0" *ngIf="!isUpdate" class="btn btn-add blue-button" type="submit">
                    {{'config-system.ADD' |translate |translateKey}}
                </button>
                <button tabindex="0" *ngIf="isUpdate" class="btn btn-add blue-button" type="submit">
                    {{'config-system.UPDATE' |translate |translateKey}} 
                </button>
                <button tabindex="0" class="btn btn-add grey-button" type="button" (click)="closePopUp()"  data-dismiss="modal" aria-label="Close">
                    {{'config-system.CANCEL' |translate |translateKey}} 
                </button>
            </div>
        </form>
    </modal-content>
    <modal-footer>

    </modal-footer>
</modal>
    <!-- end -->
<div id="wrapper">
    <section class="center-75per-width">
        <section>
             <div class="color-blue">                    
                <h2></h2>                    
            </div> 
        </section>
        <div class="clearfix">
            <div class="col-md-6 no-padding">
                <div class="row">
                    <div class="col-md-6">
                        <select tabindex="0" id="autofocus-element" autofocus class="form-control ng-pristine  ng-touched" [(ngModel)]="operatingCountry">
                            <option *ngIf ="isCountriesLoading" [value]="0">Loading...</option>
                            <option [value]="0">{{'config-system.Operating Country' |translate}}</option>
                            <option *ngFor="let country of operatingCountries | orderBy:'name'" [value]="country.id">{{country.name}}</option>
                        </select>
                    </div>
                    <div class="col-md-6 floating-input floatLabelContainer">
                        <input tabindex="0" type="text" float-label class="form-control" [(ngModel)]="ticketType" placeholder="{{'config-system.Ticket Type Name' |translate |translateKey}}"
                        (keyup.enter)="onSearch()" />
                    </div>
                </div>
            </div>
            <div class="col-md-6  right-padding-0">
                <button class="btn blue-button" tabindex="0" type="submit" (click)="onSearch()"  id="search-button">{{'config-system.Search' |translate |translateKey}}</button>
                <button class="btn grey-button" tabindex="0" type="button" (click)="clearFields()">{{'config-system.Cancel' |translate |translateKey}}</button>  
                
            </div>
            <div class="clearfix text-left col-md-12 no-padding">
                <a autofocus="" tabindex="0" id="processor-btn" (click)="opeCreateTicketModal()"  *ngIf="createTypePermission">
                    <span class="glyphicon glyphicon-plus"></span> &nbsp;&nbsp;&nbsp;{{'config-system.ADD NEW' |translate |translateKey}}
                </a>
            </div>
        </div>
             
        
        
        <!-- <button type="button" class="btn btn-ad" (click)="opeCreateTicketModal(true)">
                <i class="fa fa-plus pad-r-8"></i> {{'config-system.Add New' |translate}}
                 [routerLink]="['/admin/customerservice/configuration/ticketType']"
            </button> -->
         
         
        <div class=" clearfix">
            <table class="table table-hover table-striped custab">
                <thead>
                    <tr>
                        <th (click)="sortTableByColumn('Value')" class="pointer">{{'config-system.Ticket Type' |translate |translateKey}}&nbsp;
                            <i class="fa" [ngClass]="{'fa-sort': sortColumn != 'Value', 'fa-sort-asc': (sortColumn == 'Value' && !isDesc), 'fa-sort-desc': (sortColumn == 'Value' && isDesc) }"
                                aria-hidden="true"> </i>
                        </th>
                        <th (click)="sortTableByColumn('OperatingCountry')" class="pointer">{{'config-system.Operating Country' |translate |translateKey}}&nbsp;
                            <i class="fa" [ngClass]="{'fa-sort': sortColumn != 'OperatingCountry', 'fa-sort-asc': (sortColumn == 'OperatingCountry' && !isDesc), 'fa-sort-desc': (sortColumn == 'OperatingCountry' && isDesc) }"
                                aria-hidden="true"> </i>
                        </th>
                        <th (click)="sortTableByColumn('rowStatusId')" class="pointer">{{'config-system.Status' |translate |translateKey}}&nbsp;
                            <i class="fa" [ngClass]="{'fa-sort': sortColumn != 'rowStatusId', 'fa-sort-asc': (sortColumn == 'rowStatusId' && !isDesc), 'fa-sort-desc': (sortColumn == 'rowStatusId' && isDesc) }"
                                aria-hidden="true"> </i>
                        </th>
                        <th *ngIf="(([permission.MANAGE_DEPARTMENT_EDIT] | hasAccess) || ([permission.MANAGE_DEPARTMENT_DEACTIVATE] | hasAccess) || ([permission.MANAGE_DEPARTMENT_EDIT] | hasAccess))"></th>
                    </tr>
                </thead>
               <tbody>
                    <tr *ngFor="let ticketType of ticketTypes | paginate: { id:'ticketTypes-pagination', itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount }">
                        <td *ngIf="ticketType.operatingCountryName!==null && editTypePermission"><a (click)="editTicketTypeForm(ticketType.id)">{{ticketType.name}}</a></td>
                        <td *ngIf="ticketType.operatingCountryName==null && editTypePermission">{{ticketType.name}}</td>
                        <td *ngIf="ticketType.operatingCountryName==null && !editTypePermission">{{ticketType.name}}</td>
                        <td *ngIf="ticketType.operatingCountryName && !editTypePermission">{{ticketType.name}}</td>
                        <td *ngIf="ticketType.operatingCountryName">{{ticketType.operatingCountryName}}</td>
                        <td *ngIf="!ticketType.operatingCountryName">ALL</td>
                        <td>{{rowStatus[ticketType.rowStatusId]}}</td>
                        <td class="options" *ngIf="(([permission.MANAGE_DEPARTMENT_EDIT] | hasAccess) || ([permission.MANAGE_DEPARTMENT_DEACTIVATE] | hasAccess) || ([permission.MANAGE_DEPARTMENT_EDIT] | hasAccess))">
                            <!-- <i class="fa text-primary fa-pencil showpopup btn-EditIcon" *ngIf="((ticketType.rowStatusId==1)&& ([permission.MANAGE_DEPARTMENT_EDIT] | hasAccess)) && ticketType.operatingCountryName" title="{{'config-system.Edit Ticket Type' |translate}}"  [routerLink]="['/customerservice/configuration/ticketType/'+ticketType.id]"></i> -->
                            <span *ngIf="((([permission.MANAGE_DEPARTMENT_EDIT] | hasAccess) && (ticketType.rowStatusId==1)) || ([permission.MANAGE_DEPARTMENT_DEACTIVATE] | hasAccess)) && ticketType.operatingCountryName"
                                class="nav ellipsis-dp" style="display:inline-block">
                                <li dropdown id="login-menu{{i}}" class="dropdown">
                                    <a dropdownToggle class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                       
                                    </a>
            
                                </li>
                            </span>
                        </td>
                        
                    </tr>
                </tbody>
                <tbody *ngIf="pageCount===0">
                    <tr align="center">
                        <td colspan="4">{{'ticketing-system.No records found.' |translate |translateKey}}</td>
                    </tr>
                </tbody>
            </table>
          {{pageCount}} {{'ticketing-system.record(s) found' |translate}}
          <pagination-controls [id]="paginationInstance.id" (pageChange)="pageChange($event)" class="pull-right"></pagination-controls>
        </div>

        
        <!--<pagination-controls (pageChange)="pageChange($event)" class="pull-right"></pagination-controls>-->
        <!-- </div> -->
        <!-- </div> -->
        <!-- </div> -->
        <!-- </div> -->
        <!-- End Content -->
    </section>
    <!--/Body Section End-->
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/configuration/ticketType-search.component.html